export const environment = process.env.NODE_ENV || 'development';
export const isProduction = environment === 'production'
    && window.location.host.includes('foodforgoodmealsolutions.com');
